import { useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { translate } from "app/filters/i18nFilter";
import { apiClient, getQueryKey } from "app/modules/api-client";
import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { isResourceNotFoundError } from "app/services/fetchService";

interface IUseAlertsSubscriptionsStatusQueryOptions {
    enabled?: boolean;
}

export const useAlertsSubscriptionsStatusQuery = (
    activationSetId: string,
    options?: IUseAlertsSubscriptionsStatusQueryOptions,
) => {
    const { showErrorToast } = useToasts();

    return useQuery({
        ...options,
        queryKey: getQueryKey({
            tag: "Alerts",
            methodName: "userdataActivationSubscriptionsAlertsDetail",
            args: [activationSetId],
        }),
        queryFn: async () => {
            try {
                const result = await apiClient.Alerts.userdataActivationSubscriptionsAlertsDetail(activationSetId);

                return result;
            } catch (error) {
                // Ignore RESOURCE_NOT_FOUND error
                if (
                    isResourceNotFoundError(error)
                ) {
                    return null;
                }

                Sentry.errorTracker({
                    e: error,
                    message: "Failed to load Alerts.userdataActivationSubscriptionsAlertsDetail data",
                    level: "error",
                    params: {
                        extra: {
                            activationSetId,
                        },
                    },
                });

                showErrorToast(
                    translate("common.api.error", { error: error instanceof Error ? error.message : String(error) }),
                );
                throw error;
            }
        },
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};
